import type { TOC } from '@ember/component/template-only';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';

interface SettingsCentralMappingTablesCellsTdValueSignature {
  Args: {
    cellData: string;
  };
}

const SettingsCentralMappingTablesCellsTdValue = <template>
  <div class="overflow-hidden text-ellipsis whitespace-nowrap">
    {{#if @cellData}}
      {{@cellData}}

      <EmberTooltip
        @side="bottom"
        @tooltipClass="default-tooltip default-tooltip--large"
      >
        <p class="text-200--regular">{{@cellData}}</p>
      </EmberTooltip>
    {{else}}
      {{t "general.missing"}}
    {{/if}}
  </div>
</template> satisfies TOC<SettingsCentralMappingTablesCellsTdValueSignature>;

export default SettingsCentralMappingTablesCellsTdValue;
